import React, { useEffect } from "react";
import { makeStyles, createStyles, Theme as AugmentedTheme } from "@material-ui/core/styles";
import Props from "./index.d";
import MenuItem from "@material-ui/core/MenuItem";
import useGetForeignKeyList from "./useGetForeignKeyListStudienberater";
import Select, { SelectProps } from "components/atomics/Select";
import FormHeader from "components/atomics/FormHeader";
const useStyles = makeStyles(
  (theme: AugmentedTheme) =>
    createStyles({
      foreignKeySelectorIntStudienberaterBox: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      },
    }),
  { name: "foreignKeySelector" }
);
const ForeignKeySelectorIntStudienberater: React.FC<Props> = (props) => {
  const {
    data: { state, setAndSave },
    disabled,
    title,
    pickDefaultFirst,
    foreignKeyParams,
    label,
    noHeader,
    errors,
    noFormControlMarginTop = false,
    mitarbeiterTypeId = 7,
  } = props;
  const elems = useGetForeignKeyList({ foreignKeyParams, mitarbeiterTypeId });
  useEffect(() => {
    if (pickDefaultFirst && !state && !!elems && elems.length) setAndSave(elems[0].value);
  }, [elems, state, pickDefaultFirst]);

  const classes = useStyles(props);
  return (
    <div className={classes.foreignKeySelectorIntStudienberaterBox}>
      {!noHeader && <FormHeader title={title} />}

      <Select
        label={label}
        setState={(value) => setAndSave(+value)}
        state={state}
        items={elems}
        disabled={disabled}
        error={!!errors?.length}
        helperText={errors?.join(" ") ?? undefined}
        noFormControlMarginTop={noFormControlMarginTop}
      />
    </div>
  );
};

export default ForeignKeySelectorIntStudienberater;
